//PROD - V2 Configuration
// Uses env var if set, falls back to workflow86.com for backward compatibility
const ROOT_DOMAIN = import.meta.env.VITE_ROOT_DOMAIN || 'workflow86.com';
// Empty VITE_API_ADDRESS means "use relative paths" (proxied through Vite dev server).
// Only fall back to the absolute URL when the var is truly undefined.
const API_BASE = import.meta.env.VITE_API_ADDRESS !== undefined
  ? import.meta.env.VITE_API_ADDRESS
  : `https://api.${ROOT_DOMAIN}`;

// Log warning if using fallback (helps identify missing config in logs)
if (typeof window !== 'undefined' && !import.meta.env.VITE_ROOT_DOMAIN) {
  console.warn('[config] VITE_ROOT_DOMAIN not set, using default: workflow86.com');
}

const config = {
  VERSION: '0.0.1',
  API_ADDRESS:
    import.meta.env.VITE_ENV === 'local'
      ? ''
      : API_BASE,
  // Templates API - V2 uses ALB
  TEMPLATES_API_ADDRESS: `${API_BASE}/project-service/templates`,
};

config.FORM = {
  QUERY_URL: 'http://localhost:3000/form',
  // IMPORTANT: FORM_FRONT_END should NOT have a trailing slash
  // All paths should start with / (e.g., /form/...)
  FORM_FRONT_END: (import.meta.env.VITE_FORM_URL || `https://form.${ROOT_DOMAIN}`).replace(/\/+$/, ''),
};

config.AGENT = {
  // IMPORTANT: AGENT_FRONT_END should NOT have a trailing slash
  AGENT_FRONT_END: (import.meta.env.VITE_AGENT_URL || `https://agent.${ROOT_DOMAIN}`).replace(
    /\/+$/,
    ''
  ),
};

// Utility function to safely build form URLs - prevents double/missing slash issues
config.buildFormUrl = (path) => {
  const base = config.FORM.FORM_FRONT_END.replace(/\/+$/, ''); // Remove trailing slashes
  const cleanPath = path.startsWith('/') ? path : `/${path}`; // Ensure leading slash
  return `${base}${cleanPath}`;
};

config.buildAgentChatUrl = (token) => {
  const base = config.AGENT.AGENT_FRONT_END.replace(/\/+$/, '');
  return `${base}/agent-chat/${token}`;
};

config.AI_SERVICE_BASE =
  import.meta.env.VITE_ENV === 'local'
    ? '/ai-service'
    : `${API_BASE}/ai-service`;

config.FILE_SERVICE = {
  QUERY_URL: `${API_BASE}/ai-service/file/get`,
};

config.PREVIEW_FORM_URL = `https://form.${ROOT_DOMAIN}/form/25d1cb58-8c01-4e97-bfb9-de18c43233c0`;

config.ROOT_DOMAIN = ROOT_DOMAIN;

config.HEADER = {
  'Content-Type': 'application/json',
};

//Stripe
config.PUBLISHABLEKEY = 'pk_live_CSn7ahwRzAqZNfkIuGAGcXHJ00pTU61FeP';

config.PUBLISHABLEKEY_V2 =
  'pk_live_51POPQbS6t8BhbvCSyIQzc0orQKtbcI8bwGz5IgCsID4JIZis3TFNRz5sBPSxeVT0QNlHBbT8LFjdgnA3bvy5HoQm00gDbYTHxm';

// Use explicit env-provided key when set. Fallback is the production website key.
config.CAPTCHA = import.meta.env.VITE_CAPTCHA_KEY || '6LfrsPgZAAAAAANMXn-uTu9SSlepaQJ3amx_7Zb9';

// Webhook URLs use the API base (follows VITE_API_ADDRESS in staging, falls back to api.ROOT_DOMAIN)
config.WEBHOOK_URL = `${API_BASE}/webhook`;

config.WEBHOOK_ENDPOINT = {
  SAMPLE: `${API_BASE}/webhook/catch-sample`,
  PRODUCTION: `${API_BASE}/webhook`,
};

// Zapier endpoints (use same API base)
config.ZAPIER_ENDPOINT = {
  SAMPLE: `${API_BASE}/zapier/catch-sample`,
  PRODUCTION: `${API_BASE}/zapier`,
};

// ------- Layout constants ------- //
config.SIDEBAR_WIDTH_CLOSED = 48;
config.SIDEBAR_WIDTH_OPEN = 204;
config.CANVAS_HEADER_HEIGHT = 57;

// ------- Pane widths configs ------- //
config.PANE_WIDTH = '600px';
config.FORM_PANE_WIDTH = '600px';
config.FULL_SCREEN_WIDTH = '97.5%';
config.AI_WORKFLOW_BUILDER_PANE_WIDTH = '400px';
config.AI_COMPONENT_BUILDER_PANE_WIDTH = '400px';
config.TEST_PANE_WIDTH = '400px';
config.SESSION_HISTORY_PANEL_WIDTH = '275px';
config.COMPONENT_BUILDER_BASE_WIDTH = '600px';
config.COMPONENT_BUILDER_EXPANDED_WIDTH = '75%';
config.TRANSLATION_BOTH_PANELS_OPEN = 'translateX(-600px)';
config.TRANSLATION_BOTH_PANELS_OPEN_NOT_FORM = 'translateX(-600px)';
config.TRANSLATION_ONLY_TEST_PANEL_OPEN = 'translateX(0px)';
config.TRANSLATION_ONLY_TEST_PANEL_OPEN_FORM = 'translateX(-400px)';
config.TRANSLATION_ONLY_TEST_PANEL_OPEN_NOT_FORM = 'translateX(-400px)';
config.TRANSLATION_ONLY_BUILDER_PANEL_OPEN = 'translateX(0px)';
config.TRANSLATION_ONLY_BUILDER_PANEL_OPEN_FORM = 'translateX(-400px)';
config.TRANSLATION_ONLY_BUILDER_PANEL_OPEN_NOT_FORM = 'translateX(-400px)';

// Progress view
config.SESSION_LOGS_LIST_WIDTH = '400px';
config.SESSION_LOGS_COMPONENT_INFO_PANE_WIDTH_IN_SPLIT_VIEW = '500px';
config.SESSION_LOGS_COMPONENT_INFO_PANE_WIDTH = '40%';

config.AI_WORKFLOW_BUILDER_PANE_MAX_WIDTH_IN_PX = 400;

config.OAUTH = {
  // OAuth callback via oauth.workflow86.com (handled by OAuthCallbackFilter in integrations-service)
  CALLBACK_URL:
    import.meta.env.VITE_ENV === 'local'
      ? 'https://faea-103-100-226-144.ngrok-free.app/oauth/callback'
      : `https://oauth.${ROOT_DOMAIN}/callback`,
};

config.WEBHOOK_URL = `${API_BASE}/webhook/`;

config.PIPEDREAM_ENV = 'production';

config.AWS = {
  // Cognito region stays ap-southeast-2 (shared user pool)
  REGION: import.meta.env.VITE_AWS_REGION || 'ap-southeast-2',
  // V2 production bucket
  DOMAIN: `.${ROOT_DOMAIN}`,
};

config.GOOGLE = {
  CLIENT_ID: '541992205730-eaa8et59jir07ttls4vqgci5hpe5hdr5.apps.googleusercontent.com',
};

config.APP_URL = import.meta.env.VITE_APP_URL || `https://app.${ROOT_DOMAIN}`;

export default config;
